module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "progress-table",
      "title": "Progress",
      "icon": "fa fa-share-alt",
      "hide-org-badge": "",
      "show-search": "false",
      "url": '/actions/site/' + _vm.rowData.id + '/null/prg',
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7c4ea2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/calendar/Progress.vue
// module id = 1622
// module chunks = 0